import { ChapterTextEnum } from './chapter-text.enum';
import { ChapterEnum } from './chapter.enum';

export const environment = {
  production: false,
  cognitoIdentityService: 'CognitoIdentityServiceProvider.5r5t98loa5rs8mb6sfefb7uo5l',
  webServiceEndpoint: 'https://xx320wbhm2.execute-api.us-east-1.amazonaws.com/dev/assessments/',
  webServiceAssessment:
    'https://xx320wbhm2.execute-api.us-east-1.amazonaws.com/dev/assessments-pa/',
  GrowthEndpoint: 'https://xx320wbhm2.execute-api.us-east-1.amazonaws.com/dev/growth-matrix/',
  endpointMultimedia: 'https://d3jvm6ee97l28q.cloudfront.net',
  webServiceAchievements:
    'https://hnap5j23gd.execute-api.us-east-1.amazonaws.com/dev/achievements/api/v2/',
  webServiceChapterAdministration:
    'https://xx320wbhm2.execute-api.us-east-1.amazonaws.com/dev/administration/apis/graphql',
  webServiceChapter: 'https://hnap5j23gd.execute-api.us-east-1.amazonaws.com/dev/administration/',
  webServiceScheduling:
    'https://hnap5j23gd.execute-api.us-east-1.amazonaws.com/dev/schedule/api/v1/',
  webGrowthRoute: 'https://hnap5j23gd.execute-api.us-east-1.amazonaws.com/dev/growth-route/api/v1/',
  webServiceMapRating: 'https://hnap5j23gd.execute-api.us-east-1.amazonaws.com/dev/map-rating/',
  webServiceMapConfiguration:
    'https://hnap5j23gd.execute-api.us-east-1.amazonaws.com/dev/map-configuration/',
  webComments: 'https://hnap5j23gd.execute-api.us-east-1.amazonaws.com/dev/comments/api/comments',
  webAttachments:
    'https://xx320wbhm2.execute-api.us-east-1.amazonaws.com/dev/comments/api/attachments',
  webServiceSkillset: 'https://hnap5j23gd.execute-api.us-east-1.amazonaws.com/dev/skillset/',
  chapters: {
    [ChapterEnum.FRONTEND]: ChapterTextEnum.FRONTEND,
    [ChapterEnum.BACKEND]: ChapterTextEnum.BACKEND,
  },
  assessmentKey: 'x-api-key-dev',
  assessmentValue: 'NFeAmHT4lB5UAbKHGP97Q5wkb20BsrfUa7VXPcWf',

  applicationId: 'f634bafd-380c-4d88-a9e6-050ab0096898',
  clientToken: 'pub01907bf79664a66017beaa3675d0b1bf',
  site: 'datadoghq.com',
  service: 'pragma-rum-creci-dev',
  env: 'dev',
  defaultPrivacyLevel: 'allow',
  productionFrontendUrl: 'https://mapadecrecimiento.pragma.com.co/login',
  surveyFeedbackUrl: 'https://shirt-mess-64667085.figma.site/',
  jarvisChatEnabled: true,
  jarvisWsUrl: 'wss://w03x342gzd.execute-api.us-east-1.amazonaws.com/v1',
  jarvisCognitoClientId: '5r5t98loa5rs8mb6sfefb7uo5l',
  jarvisSource: 'creci',
  jarvisEvaluatorWsUrl: 'wss://yj2bxzcqbe.execute-api.us-east-1.amazonaws.com/v1',
};
